import { combineReducers } from 'redux';

import * as TYPES from './TYPES';

const initialSearchBarState = {
  input: '',
  selected: 'Registration',
  selectedNum: '20'
};

const initialSearchHistoryState = {
  isFetchingHistory: false,
  history: [],
  showHistory: false
};
const initialSearchResultState = {
  isFetchingResult: false,
  total: 0,
  currentPage: 0,
  searchResults: [],
  dashboardID: null,
  sort: ''
};

const searchBarReducer = (state = initialSearchBarState, action = {}) => {
  switch (action.type) {
    case TYPES.INPUT_TEXT_CHANGE:
      return { ...state, ...action.payload };
    case TYPES.SELECT_TYPE_CHANGE:
      if (state.selected === action.payload.selected) return state;
      return {
        ...state,
        ...action.payload
      };
    case TYPES.SELECT_NUM_CHANGE:
      if (state.selectedNum === action.payload.selectedNum) return state;
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

const historyReducer = (state = initialSearchHistoryState, action = {}) => {
  switch (action.type) {
    case TYPES.SET_SHOW_HISTORY:
      return { ...state, ...action.payload };
    case `${TYPES.FETCH_SEARCH_HISTORY}_PENDING`:
      return Object.assign({}, state, {
        isFetchingHistory: true
      });

    case `${TYPES.FETCH_SEARCH_HISTORY}_FULFILLED`:
      return Object.assign({}, state, {
        isFetchingHistory: false,
        history: action.payload.data.Details
      });

    case `${TYPES.FETCH_SEARCH_HISTORY}_REJECTED`:
      return {
        isRejected: true,
        error: 'Fetch Search History Failed'
      };
    /** ACTION TYPES FOR SAVE_SEARCH_TO_HISTORY START */
    case `${TYPES.SAVE_SEARCH_TO_HISTORY}_PENDING`: {
      const history = state.history.slice();
      if (!history.find(search => search.SearchTerm === action.meta)) {
        history.pop();
        history.unshift({ SearchTerm: action.meta });
      }
      // remove duplicates
      // history = history.filter((thing, index, self) => self.findIndex((t) => {return t.SearchTerm === thing.SearchTerm; }) === index)
      return Object.assign({}, state, {
        history
      });
    }

    case `${TYPES.SAVE_SEARCH_TO_HISTORY}_REJECTED`:
      return {
        isRejected: true,
        error: 'Save Search History Failed'
      };
    default:
      return state;
  }
};

const categoryHistoryReducer = (
  state = initialSearchHistoryState,
  action = {}
) => {
  switch (action.type) {
    case `${TYPES.FETCH_SEARCH_CATEGORY_HISTORY}_PENDING`:
      return Object.assign({}, state, {
        isFetchingHistory: true
      });

    case `${TYPES.FETCH_SEARCH_CATEGORY_HISTORY}_FULFILLED`:
      return Object.assign({}, state, {
        isFetchingHistory: false,
        history: action.payload.data.Details
      });

    case `${TYPES.FETCH_SEARCH_CATEGORY_HISTORY}_REJECTED`:
      return {
        isRejected: true,
        error: 'Fetch Search History Failed'
      };
    default:
      return state;
  }
};

const searchResultReducer = (state = initialSearchResultState, action = {}) => {
  switch (action.type) {
    case `${TYPES.FETCH_SEARCH_RESULT}_PENDING`:
      return {
        ...state,
        ...{
          isFetchingResult: true,
          searchResults: [],
          total: 0,
          dashboardID: null
        }
      };

    case `${TYPES.FETCH_SEARCH_RESULT}_FULFILLED`:
      return {
        ...state,
        ...{
          isFetchingResult: false,
          searchResults: action.payload.Details,
          total: action.payload.Total,
          dashboardID: action.payload.ProfileDashboardId,
          currentPage: action.payload.currentPage
        }
      };

    case `${TYPES.FETCH_SEARCH_RESULT}_REJECTED`:
      return {
        ...state,
        ...{
          isRejected: true,
          error: 'Fetch Search Result Failed'
        }
      };
    default:
      // console.log('result default nothing change', action);
      return state;
  }
};

const GlobalSearchReducer = combineReducers({
  searchBar: searchBarReducer,
  searchHistory: historyReducer,
  searchCategoryHistory: categoryHistoryReducer,
  searchResult: searchResultReducer
});

export default GlobalSearchReducer;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/store/reducer.js